module.exports = __webpack_public_path__ + "static/media/main01.fad92fd5.jpg";